module.exports = __webpack_public_path__ + "static/media/new-complement.6e1b476a.svg";